import { ImageUploader as OriginalImageUploader, Toast, } from 'antd-mobile';
import React, { useImperativeHandle, useRef, cloneElement, forwardRef, useContext, } from 'react';
import './index.scss';
import { prefixCls } from '../../utils/style';
const OneM = 1024 * 1024;
const isVideo = (url) => {
    const uri = url.toLowerCase();
    return uri.endsWith('mp4') || uri.endsWith('mov') || uri.endsWith('webm');
};
const ImageUploader = (props, ref) => {
    const { appHelper } = useContext(window.__appContext);
    const fetch = appHelper.requestHandlersMap.fetch;
    const { upload: originalUpload, renderItem: originalRenderItem, action, fileName = 'file', headers, onPreview: originalOnPreview, beforeUpload: originalBeforeUpload, imgSizeLimit, videoSizeLimit, prefixUrl, } = props;
    const nativeButtonRef = useRef(null);
    useImperativeHandle(ref, () => {
        const { nativeElement } = nativeButtonRef.current;
        return nativeElement;
    });
    const upload = async (file) => {
        if (action) {
            const formData = new FormData();
            formData.append(fileName, file);
            try {
                const res = await fetch({
                    uri: action,
                    method: 'POST',
                    params: formData,
                    requestType: 'form',
                    headers,
                });
                return {
                    url: prefixUrl ? prefixUrl + res.data : res.data,
                    extra: {
                        file,
                        originalUrl: res.data,
                    },
                };
            }
            catch (e) {
                console.warn(e);
                throw e;
            }
        }
        const result = await originalUpload?.(file);
        return {
            ...result,
            extra: {
                ...result?.extra,
                file,
            },
        };
    };
    const beforeUpload = (file, files) => {
        if (file.type.includes('image') && Number(imgSizeLimit) > 0) {
            if (file.size > Number(imgSizeLimit) * OneM) {
                Toast.show({ icon: 'fail', content: `大小超出限制，图片最大为${imgSizeLimit}M` });
                return null;
            }
        }
        else if (file.type.includes('video') && Number(videoSizeLimit) > 0) {
            if (file.size > Number(videoSizeLimit) * OneM) {
                Toast.show({ icon: 'fail', content: `大小超出限制，视频最大为${videoSizeLimit}M` });
                return null;
            }
        }
        return originalBeforeUpload ? originalBeforeUpload?.(file, files) : file;
    };
    const onPreview = (index, item) => {
        if (originalOnPreview) {
            originalOnPreview(index, item);
            return;
        }
        if (isVideo(item.url)) {
            const video = document.getElementById(item.url);
            video.addEventListener("fullscreenchange", () => {
                document.fullscreenElement === video ? video.play() : video.pause();
            });
            if (video.requestFullscreen) {
                video.requestFullscreen();
            }
            else {
                video.play();
            }
        }
    };
    const renderItem = (originNode, item, items) => {
        if (originalRenderItem) {
            return originalRenderItem?.(originNode, item, items);
        }
        const file = item.extra?.file;
        if ((file && file.type.includes('video')) || isVideo(item.url)) {
            const id = `${item.url}`;
            return (React.createElement("div", { className: `${prefixCls}preview-wrapper` },
                React.createElement("div", { className: "video-wrapper" },
                    React.createElement("video", { id: id, width: "100%", height: "100%", src: item.url, autoPlay: false }),
                    React.createElement("div", { className: "play-button-wrapper" },
                        React.createElement("span", { className: `${prefixCls}play-button` }))),
                cloneElement(originNode, {
                    url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgEB/afCF5IAAAAASUVORK5CYII=',
                    onClick: () => {
                        onPreview(items.indexOf(item), item);
                    },
                })));
        }
        return originNode;
    };
    return (React.createElement(OriginalImageUploader, Object.assign({}, props, { upload: upload, renderItem: renderItem, onPreview: onPreview, beforeUpload: beforeUpload, ref: nativeButtonRef })));
};
export default forwardRef(ImageUploader);
